var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Memory_data, _MemorySync_data;
export class Memory {
    constructor() {
        _Memory_data.set(this, null);
    }
    read() {
        return Promise.resolve(__classPrivateFieldGet(this, _Memory_data, "f"));
    }
    write(obj) {
        __classPrivateFieldSet(this, _Memory_data, obj, "f");
        return Promise.resolve();
    }
}
_Memory_data = new WeakMap();
export class MemorySync {
    constructor() {
        _MemorySync_data.set(this, null);
    }
    read() {
        return __classPrivateFieldGet(this, _MemorySync_data, "f") || null;
    }
    write(obj) {
        __classPrivateFieldSet(this, _MemorySync_data, obj, "f");
    }
}
_MemorySync_data = new WeakMap();
